module.exports = __webpack_public_path__ + "static/media/corporate-catering-2.89fb7e4d.jpg";